/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlCouponDiscount
 */
export interface ControlCouponDiscount {
    /**
     * 
     * @type {string}
     * @memberof ControlCouponDiscount
     */
    coupon_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCouponDiscount
     */
    display_code?: string;
}

/**
 * Check if a given object implements the ControlCouponDiscount interface.
 */
export function instanceOfControlCouponDiscount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "coupon_id" in value;

    return isInstance;
}

export function ControlCouponDiscountFromJSON(json: any): ControlCouponDiscount {
    return ControlCouponDiscountFromJSONTyped(json, false);
}

export function ControlCouponDiscountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCouponDiscount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'coupon_id': json['coupon_id'],
        'display_code': !exists(json, 'display_code') ? undefined : json['display_code'],
    };
}

export function ControlCouponDiscountToJSON(value?: ControlCouponDiscount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'coupon_id': value.coupon_id,
        'display_code': value.display_code,
    };
}

